import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import {MychampService} from '../services/mychamp.service'
import {MasterService} from '../services/master.service'
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-feedtls',
  templateUrl: './feedtls.component.html',
  styleUrls: ['./feedtls.component.css'],
  providers:[MychampService,MasterService]
})
export class FeedtlsComponent implements OnInit {
feedtls:any[];
feedmet:any[];
feesum:any={};
ipactive:any="";
payip:any="";
objfeesh:any={};
arrfeerech:any=[];
closeResult: string;
objvhead:any={};
@ViewChild('form') form: ElementRef;
encRequest: String;
accessCode: String;
modalOptions:NgbModalOptions;
private modalRef: NgbModalRef;
redirect_url:string='';//'http://106.51.136.76/Expzpayapi/api/payredirect';//
cancel_url:string='';//'http://106.51.136.76/Expzpayapi/api/payredirect'//'https://plvglobal.com/PHPpayment/ccavResponseHandler.php';

constructor(private mservice: MychampService,private msservice: MasterService,private modalService: NgbModal) {this.getpayip(); }

  ngOnInit(): void {
    this.getfees();


    
  }

  getfees() {
    //var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.getfees()
        .subscribe( 
        resultArray => {
            console.log('assignments', resultArray);
           this.feedtls=resultArray.GetFeeStructResult;
           this.feesum=resultArray.GetFeesum;
this.getactiveip();
        },
        error => console.log("Error :: " + error)
        )
  }

  
 getactiveip()
 {
   this.msservice.getipurl()
   .subscribe(
          resultArray =>{
  // this.liservice.Getdashboarddata('dashcounts')
     console.log('result-dashcounts',resultArray) ;
     this.ipactive=resultArray;
     
     //this.getprofiledata();

     },
    error => console.log('Error :: ' + error)
 );
 }

 getpayip()
 {
   this.msservice.getpayipurl()
   .subscribe(
          resultArray =>{
  // this.liservice.Getdashboarddata('dashcounts')
     console.log('result-dashcounts',resultArray) ;
     this.payip=resultArray;
     if(resultArray=="http://43.247.158.89")
     {
      this.accessCode="AVLT16LI65AH45TLHA";
      this.redirect_url='http://43.247.158.89:8082/mychamp/api/v3/ccavResponseHandler.php';
      this.cancel_url='http://43.247.158.89:8082/mychamp/api/v3/ccavResponseHandler.php';
     }

     else if(resultArray=="http://106.51.141.70")
     {
      this.accessCode="AVLT16LI65AH44TLHA";
      this.redirect_url='http://106.51.141.70:8082/mychamp/api/v3/ccavResponseHandler.php';
      this.cancel_url='http://106.51.141.70:8082/mychamp/api/v3/ccavResponseHandler.php';
     }
     //this.getprofiledata();

     },
    error => console.log('Error :: ' + error)
 );
 }

 printpayreceipt(stuid,recid,vhno,inid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.ipactive+"api/v3/fpdf181/pdfreports/payreceipt.php?clcd="+clcd+"&aycd="+aycd+"&stuid="+stuid+"&recid="+recid+"&vhno="+vhno+"&inid="+inid;
   window.open(url,'','_blank');

//http://43.247.158.94:8081/mycampuz/api/v3/fpdf181/pdfreports/payreceipt.php
   
 }

 printpayack(stuid,recid,vhno,inid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
  var url=this.ipactive+"api/v3/fpdf181/pdfreports/paymentacknowledge.php?clcd="+clcd+"&aycd="+aycd+"&stuid="+stuid+"&recid="+recid+"&vhno="+vhno+"&inid="+inid;
   window.open(url,'','_blank');

//http://43.247.158.94:8081/mycampuz/api/v3/fpdf181/pdfreports/payreceipt.php
   
 }
 openmdlpartpays(content,objdata,vhno) {
debugger
  console.log('objdata',objdata);
  this.objvhead=objdata;

  this.getfeerech(vhno);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


openpaymdl(content,objdata) {
  debugger
    console.log('objdata',objdata);
    //this.objfeesh=objdata;
    this.paymentrequestdata(objdata);
  
    //this.getfeerech(vhno);
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  

getfeerech(vhno)
{
  debugger
  
   this.mservice.feerech('selrech',vhno)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    
    this.arrfeerech = resultArray;
   // this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
   
    },
   error => console.log("Error :: " + error)
)
  }

  paymentrequestdata(obj)
  {
    debugger
    
     this.mservice.paymentrequestdata(obj)
    
    //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      
      this.objfeesh = resultArray;
     // this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
     
      },
     error => console.log("Error :: " + error)
  )
    }
  paymentapi()
  {
    //this.accessCode = 'AVMJ77JD33AO90JMOA';
   // this.accessCode='AVDF95HJ89AZ06FDZA';
      //var formdata=this.enqdata;
//     const orderParams = {

//       order_id: '1234',
//       currency: 'INR',
//       amount: '1',
//       language:'EN',
//       redirect_url: this.redirect_url,
//       cancel_url:this.cancel_url,
//       billing_name: 'PLV Testing',
//       billing_country: "India",
//   billing_tel: '9916438089',
//   billing_email:'vinayn143@gmail.com',
//   billing_address:'banagalore',
//   billing_city:'banagalore',
//   billing_state:'Karnataka',

//   merchant_id:'202263',
//   sub_account_id:'MYC009',
//   billing_zip:'560054',
//   merchant_param2: 'MYC2209',
//   merchant_param1:'123456789'


// };
   
const orderParams = {

  order_id: this.objfeesh.orderid,
  currency: 'INR',
  amount: this.objfeesh.RecAmt,
  language:'EN',
  redirect_url: this.redirect_url,
  cancel_url:this.cancel_url,
  billing_name: this.objfeesh.billingname,
  billing_country: "India",
billing_tel:this.objfeesh.billtel,
billing_email:this.objfeesh.billemail,
billing_address:this.objfeesh.billingaddress,
billing_city:this.objfeesh.billcity,
billing_state:this.objfeesh.billcity,

merchant_id:this.objfeesh.merchantid,
sub_account_id:this.objfeesh.submerchantid,
billing_zip:this.objfeesh.billingzip,
merchant_param2: this.objfeesh.cl_db,
merchant_param1:this.objfeesh.stuid+"_"+this.objfeesh.insid+"_"+this.objfeesh.deptid,
merchant_param3: this.objfeesh.recnoh,


};

      console.log('orderParams',JSON.stringify(orderParams));
    this.mservice.payapi(orderParams)
.subscribe((result:any) => {
    this.encRequest = result;
    localStorage.setItem('orderid','1234');
   // localStorage.setItem('enid',this.defId.toString());
    console.log('enqres',this.encRequest);
   setTimeout(_ => this.form.nativeElement.submit());

}, error => {
  console.log('enqres',error);
  alert('error in connection')}
);

  }
}
